export default __webpack_public_path__ + "static/media/logo_dark3.56545e31.png";